import { enrichConvertersRegistry } from '../../utils/convertersRegistry'
import { justifyContentConverterMap } from './justifyContentPropsToCss'

/**
 * Enriches the converters registry with all JustifyContent style property converters.
 * JustifyContent converters handle CSS justify-content property and related alignment values.
 */
export function enrichJustifyContentConverters(): void {
	// Register all justify-content converters
	Object.entries(justifyContentConverterMap).forEach(([key, converter]) => {
		enrichConvertersRegistry(key, converter)
	})
}
